import Text from 'components/_UI/Text';
import NotResultDashBoard from 'components/commons/NotResultDashBoard';
import React from 'react'
import styled from 'styled-components';

export default function FinancialAnalysis() {
    return (
        <ContentNotResult >
            <NotResultDashBoard
                text={
                    <Text name='subtitle'>
                        Em breve...
                    </Text>
                }
                ilustration={'analysis'}
                marginTop={'15px'}
            />
        </ContentNotResult >
    )
}

const ContentNotResult = styled.div`
    & > div {
        flex-direction: column;
    }

    & > div > picture {
        width: 45%;
    }

    & > div > div {
        width: 100%;
    }
`;